import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import '@/services/yup';
import App from '@/components/App';
import * as serviceWorker from '@/serviceWorker';
import { store, persistor } from '@/store/createStore';

// Suppress known deprecation warnings from third-party packages that require
// major upgrades to fix (@blueprintjs/core v4 → v5, react-scroll-sync upgrade).
const originalError = console.error;
console.error = function (...args: any[]) {
  if (typeof args[0] === 'string') {
    if (
      args[0].includes('ReactDOM.render is no longer supported') ||
      args[0].includes('findDOMNode is deprecated') ||
      args[0].includes('childContextTypes') ||
      args[0].includes('contextTypes')
    ) {
      return;
    }
  }
  originalError.call(console, ...args);
};

if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, { trackAllPureComponents: false });
}

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>,
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
